export const colours = {
  primary: {
    teal: {
      100: '#001F26',
      80: '#00B19B',
      60: '#00D1B6',
      40: '#00A792',
      20: '#73F2EB',
      15: '#CBF6F0',
      10: '#CEF6F0',
    },
    purple: { 100: '#2E3161', 80: '#9747FF' },
    darkGreen: { 100: '#003D4C', 80: '#1B806D', 50: '#00A18D', 40: '#788E20' },
    white: { 100: '#FFFFFF' },
    grey: {
      100: '#727677',
      90: '#767676',
      80: '#EEF0F1',
      60: '#F9F9F9',
      40: '#B8C4C6',
      20: '#D6DBDC',
    },
  },
  secondary: {
    blue: { 100: '#006A8E', 80: '#7F9EA5' },
    pink: { 100: '#A83D72' },
    red: { 100: '#8A2A2B' },
    brown: { 100: '#796E65' },
    yellow: { 100: '#F7F014', 90: '#FFCC00', 80: '#EAE300' },
  },
  informative: {
    warning: { 100: '#bf5501' },
    orange: { 100: '#FD7E14' },
    danger: { 100: '#8A2A2B' },
    success: { 100: '#1B806D' },
    error: { 100: '#D93333', 80: '#FFCFD0' },
  },
  imageGrids: {
    yellow: { 100: '#F7F014' },
  },
}
